import logger from "./logger";

class CookieStorage {
  setItem(name, value) {
    try {
      const date = new Date();
      date.setTime(date.getTime() + 1 * 24 * 60 * 60 * 1000);
      document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
        value
      )}; expires=${date.toUTCString()}; path=/`;
    } catch (err) {
      logger.error("Error setting cookie", err);
    }
  }

  getItem(name) {
    try {
      const decodedCookies = decodeURIComponent(document.cookie);
      const cookies = decodedCookies.split("; ");
      for (let cookie of cookies) {
        const [key, val] = cookie.split("=");
        if (key === name) return val;
      }
      return null;
    } catch (err) {
      logger.error("Error getting cookie", err);
      return null;
    }
  }

  removeItem(name) {
    try {
      document.cookie = `${encodeURIComponent(
        name
      )}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    } catch (err) {
      logger.error("Error removing cookie", err);
    }
  }
}

const cookieStorage = new CookieStorage();
export default cookieStorage;
